const authorizationInitialState = {
  permissions: new Set(),
  fetching: false,
};

const me = (state = authorizationInitialState, action) => {
  switch (action.type) {
    case 'FETCH_AUTHORIZATION_PERMISSIONS':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_AUTHORIZATION_PERMISSIONS_SUCCESS':
      return {
        ...state,
        fetching: false,
        permissions: new Set(action.permissions),
      };

    case 'FETCH_AUTHORIZATION_PERMISSIONS_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    default:
      return state;
  }
};

export default me;

export const getMyPermissions = (state) => state.permissions;

export const isFetchingMyPermissions = (state) => state.fetching;
